import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import { SIGNIN_USER, SIGNOUT_USER, SIGNUP_USER } from "constants/ActionTypes";
import {
  activeUserSuccess,
  changePasswordSuccess,
  hideAuthLoader,
  showAuthMessage,
  userForgetSuccess,
  userSignInSuccess,
  userSignOutSuccess,
  userSignUpSuccess,
  userExternalSignInSuccess,
  userExternalSignInCallBackSuccess
} from "../../appRedux/actions/Auth";
import { getData, postData } from "../../util/DynamicApi";
import { ACTIVE_USER, CHANGE_PASSWORD, CHANGE_USER_PASSWORD, SIGNIN_EXTERNAL_USER, SIGNIN_EXTERNAL_USER_CALLBACK, USER_FORGET } from "../../constants/ActionTypes";
import { ShowSmallError, ShowSuccess } from "../../util/MessageHelper";

const signInUserWithEmailPasswordRequest = async (userName, password) =>

  await postData(null, "Login/Login", {
    Un: userName,
    Password: password,
  })
    .then((authUser) => {
      return authUser;
    })
    .catch((error) => {
      return error.response.data;
    });

const signInExternalUserWithEmailPasswordRequest = async (nc, ver_code,office) =>
  await getData(null, "Login/ExternalLogin", {
    nc: nc,
    ver_code: ver_code,
    office:office
  })
    .then((authUser) => {
      return authUser;
    })
    .catch((error) => {
      return error.response.data;
    });

    
const signInExternalUserWithEmailPasswordCallBackRequest = async (nc, ver_code,office) =>
  await getData(null, "Login/ExternalLogin", {
    nc: nc,
    ver_code: ver_code,
    office:office
  })
    .then((authUser) => {
      return authUser;
    })
    .catch((error) => {
      return error.response.data;
    });

const RegisterRequest = async (
  userName,
  password,
  mobileNumber,
  isAgent,
  officeCode,
  postalCode,
  tel,
  managerName,
  state,
  city,
  address,
  confirmPassword
) =>
  await postData(null, "Register/Register", {
    userName: userName,
    Password: password,
    MobileNumber: mobileNumber,
    IsAgent: isAgent,
    OfficeCode: officeCode,
    PostalCode: postalCode,
    Tel: tel,
    ManagerName: managerName,
    State: state,
    City: city,
    Address: address,
    ConfirmPassword :confirmPassword
  })
    .then((authUser) => {
      return authUser;
    })
    .catch((error) => { return error.response.data; });
// const signOutRequest = async () =>
//   await auth
//     .signOut()
//     .then((authUser) => authUser)
//     .catch((error) => error);

function* createUserWithEmailPassword({ payload }) {
  const {
    UserName,
    Password,
    MobileNumber,
    IsAgent,
    OfficeCode,
    PostalCode,
    Tel,
    ManagerName,
    State,
    City,
    Address,
    ConfirmPassword
  } = payload;
  try {
    const signUpUser = yield call(
      RegisterRequest,
      UserName,
      Password,
      MobileNumber,
      IsAgent,
      OfficeCode,
      PostalCode,
      Tel,
      ManagerName,
      State,
      City,
      Address,
      ConfirmPassword
    );
    if (signUpUser.errorMessage) {

      ShowSmallError(signUpUser.errorMessage);
      yield put(hideAuthLoader());
    } else {
      localStorage.setItem("user_id", signUpUser.data);
      yield put(userSignUpSuccess(signUpUser.data));
    }
  } catch (error) {
    ShowSmallError(error);
    yield put(hideAuthLoader());
  }
}

function* signInUserWithEmailPassword({ payload }) {
  const { email, password, remember } = payload;
  try {
    const signInUser = yield call(
      signInUserWithEmailPasswordRequest,
      email,
      password
    );
    if (!signInUser || !signInUser.data || !signInUser.data.token || signInUser.errorMessage) {
      ShowSmallError(signInUser.errorMessage);
      yield put(hideAuthLoader());
    } else {
      if (remember === true) {
        localStorage.setItem("token", signInUser.data.token);
      }
      yield put(userSignInSuccess(signInUser.data.token));
    }
  } catch (error) {
    ShowSmallError(signInUser.errorMessage);
    yield put(hideAuthLoader());
  }
}
function* signInExternalUserWithEmailPassword({ payload }) {
  const { nc, ver_code, office } = payload;
  try {
    const signInUser = yield call(
      signInExternalUserWithEmailPasswordRequest,
      nc,
      ver_code,
      office
    );
    if (signInUser.errorMessage) {
      ShowSmallError(signInUser.errorMessage);
      yield put(hideAuthLoader());
    } else {
      yield put(userExternalSignInSuccess(signInUser.data));
    }
  } catch (error) {
    ShowSmallError(signInUser.errorMessage);
    yield put(hideAuthLoader());
  }
}
function* signInExternalUserWithEmailPasswordCallBack({ payload }) {
  const {token } = payload;
  try {
    // const signInUser = yield call(
    //   signInExternalUserWithEmailPasswordCallBackRequest,
    //   np,
    //   ver_code,
    //   office
    // );
    // if (signInUser.errorMessage) {
    //   ShowSmallError(signInUser.errorMessage);
    //   yield put(hideAuthLoader());
    // } else {
     
    // }

    localStorage.setItem("token", token);
    yield put(userExternalSignInCallBackSuccess(token));
  } catch (error) {
    ShowSmallError(signInUser.errorMessage);
    yield put(hideAuthLoader());
  }
}

const signOutRequest = async () =>
  await postData(null, "Login/Logout?refreshToken="+localStorage.getItem('reToken'),null)
    .then((authUser) => {
      return authUser.data;
    })
    .catch((error) => {
      return error;
    });
function* signOut() {
  try {
    let result = yield call(signOutRequest);
    if (result) {
      localStorage.removeItem("user_id");
      localStorage.removeItem("token");
      localStorage.removeItem("reToken");
      yield put(userSignOutSuccess());
    }

  } catch (error) {
    ShowSmallError(error);
    yield put(hideAuthLoader());
  }
}

export function* createUserAccount() {
  yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}
export function* signInExternalUser() {
  yield takeEvery(SIGNIN_EXTERNAL_USER, signInExternalUserWithEmailPassword);
}
export function* signInExternalUserCallBack() {
  yield takeEvery(SIGNIN_EXTERNAL_USER_CALLBACK, signInExternalUserWithEmailPasswordCallBack);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}
const setActiveRequest = async (token, userId) =>
  await postData(null, "Register/ConfirmRegister", {
    Token: token,
    UserManagementId: userId,
  })
    .then((authUser) => {
      return authUser.data;
    })
    .catch((error) => {
      return error;
    });

function* setActive({ payload }) {
  try {
    const { Token } = payload;
    const active = yield call(setActiveRequest, Token, localStorage.getItem('user_id'));
    if (active.errorMessage) {
      ShowSmallError(active.errorMessage);
      yield put(hideAuthLoader());
    } else {
      yield put(activeUserSuccess(active));
    }


  } catch (error) {
    ShowSmallError(error);
    yield put(hideAuthLoader());
  }
}

export function* doActiveUser() {
  yield takeEvery(ACTIVE_USER, setActive);
}

const recoveryPasswordRequest = async (userName, mobileNumber) =>
  await postData(null, "Forget/RecoveryPassword", {
    UserName: userName,
    MobileNumber: mobileNumber,
  })
    .then((authUser) => {
      return authUser.data;
    })
    .catch((error) => {
      return error.response.data;
    });

function* doUserForgot({ payload }) {
  try {
    let { MobileNumber, email } = payload;
    const active = yield call(recoveryPasswordRequest, email, MobileNumber);
    if (active.errorMessage) {
      ShowSmallError(active.errorMessage);
      yield put(hideAuthLoader());
    } else {
      yield put(userForgetSuccess(active));
    }


  } catch (error) {
    ShowSmallError(error);
    yield put(hideAuthLoader());
  }
}
export function* userForgot() {
  yield takeEvery(USER_FORGET, doUserForgot);
}


const changePasswordRequest = async (token, password, userId) =>
  await postData(null, "Forget/ChangePassword", {
    Token: token,
    Password: password,
    UserManagementId: userId
  })
    .then((authUser) => {
      return authUser.data;
    })
    .catch((error) => {
      return error;
    });
export const getAuth = ({ auth }) => auth.authUser;

function* doChangePassword({ payload }) {
  try {
    let { Token, Password } = payload;
    let userId = yield select(getAuth);
    const active = yield call(changePasswordRequest, Token, Password, userId);
    if (active.errorMessage) {
      ShowSmallError(active.errorMessage);
      yield put(hideAuthLoader());
    } else {
      yield put(changePasswordSuccess(active));
    }


  } catch (error) {
    ShowSmallError(error);
    yield put(hideAuthLoader());
  }
}

export function* changePassword() {
  yield takeEvery(CHANGE_PASSWORD, doChangePassword);
}
const changeUserPasswordRequest = async (token, password) =>
  await postData(token, "Forget/ChangeUserPassword", {
    Password: password
  })
    .then((authUser) => {
      return authUser.data;
    })
    .catch((error) => {
      return error;
    });
export const getToken = ({ auth }) => auth.token;
function* doChangeUserPassword({ payload }) {
  try {
    let { Password } = payload;
    let token = yield select(getToken);
    const active = yield call(changeUserPasswordRequest, token, Password);
    if (active.errorMessage) {
      ShowSmallError(active.errorMessage);
      yield put(hideAuthLoader());
    } else {
      ShowSuccess('تغییر رمز');
      yield put(hideAuthLoader());
    }


  } catch (error) {
    ShowSmallError(error);
    yield put(hideAuthLoader());
  }
}
export function* changeUserPassword() {
  yield takeEvery(CHANGE_USER_PASSWORD, doChangeUserPassword);
}
export default function* rootSaga() {
  yield all([
    fork(signInUser),
    fork(createUserAccount),
    fork(signOutUser),
    fork(doActiveUser),
    fork(userForgot),
    fork(changePassword),
    fork(changeUserPassword),
    fork(signInExternalUser),
    fork(signInExternalUserCallBack)
  ]);
}
